import { defineComponent, h } from 'vue'
import { RouterView } from 'vue-router'

export default defineComponent({
  name: 'RouteWrapper',
  inheritAttrs: false,
  setup (_, { attrs }) {
    return () => h(RouterView, attrs, {
      default: ({ Component, route }) => {
        if (!Component) return null
        const parametro = route.meta.parametroDeIdentidade
        // Cadastros que carregam no created precisam de outra instância ao trocar o ID.
        // Queries da mesma entidade preservam o formulário em andamento.
        return parametro
          ? h(Component, { key: `${String(route.name)}:${route.params[parametro]}` })
          : Component
      }
    })
  }
})
